<div class="header" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
    <img width="40px" src={{iconUrl}} alt="Icona pàrking">
    <span class="title" i18n> PARKING {{ name }}</span>
</div>

<div class="content">
    <div *ngIf="address">
        <span class="detail-name" i18n>Dirección:</span> {{address}}
    </div>
    
    <div *ngIf="timetable">
        <span class="detail-name" i18n>Horario:</span> {{timetable}}
    </div>
    
    <div *ngIf="price">
        <span class="detail-name" i18n>Tarifas:</span> {{price}}
    </div>
    
    <div *ngIf="phone">
        <span class="detail-name" i18n>Teléfono:</span> {{phone}}
    </div>
    
    <div *ngIf="type">
        <span class="detail-name" i18n>Tipo:</span> {{type}}
    </div>
    
    <div *ngIf="size > 0">
        <span class="detail-name" i18n>Capacidad:</span> {{size}}
    </div>
</div>




<div *ngIf="operador" class="source">
    <b i18n>Operador:</b> {{operador}}
    <a target="_blank" href="{{urlParkopedia}}"> <img class="logo-parkopedia" src="assets/img/parkopedia.png"></a>
</div>

